export const getTimeOption = (value: string | undefined | null) =>  value ? ({label: value, value}) : null;
